import { NuxtLink } from '#components'

// @vue/component
export default {
  name: 'ga-link-base',

  inheritAttrs: false,

  props: {
    nuxt: {
      type: Boolean,
      default: false,
    },
    // VUE3: добавлено для наглядности, чтобы отслеживать href
    href: {
      type: String,
      required: true,
    },
  },

  setup(props, { attrs }) {
    const { nuxt, href } = toRefs(props)

    const localePath = useLocalePath()
    const route = useRoute()

    const rel = computed(() => {
      const { target, rel: relInternal } = attrs

      return target === '_blank' ? 'noopener noreferrer' : relInternal
    })

    const component = computed(() => {
      const attrsInternal = { ...attrs, rel: rel.value }

      return nuxt.value && route.fullPath !== href.value
        ? {
            is: NuxtLink,
            attrs: {
              ...attrsInternal,
              to: {
                path: localePath({ path: href.value }),
              },
            },
          }
        : {
            is: 'a',
            attrs: { ...attrsInternal, href: href.value },
          }
    })

    return { component }
  },
}
